import React from 'react'
import { Button, Header, Icon, Modal, Form, Input, Card, Segment, Dropdown,Radio } from 'semantic-ui-react';

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaypalCheckoutButton from "../common/PaypalCheckoutButtonConstancias";

const ModalReconocimiento = ({showModal, closeModal, icono, download, texto, titulo, datos=[], onChange, errors=[], strings, curso, cursosConstancias,handleChangePago, cursoPago, handleApprove, descargarConstancia, onValidar,datosValidacion }) => (
  <Modal open={showModal} basic size='fullscreen'>
     <Modal.Content>
 <Card centered>
    <Card.Content>
     <Header icon={icono} content={titulo} />
     <Card.Description >
        Para acceder a la constancia debes haber estado mínimo en el 80% de la charla, haber llenado los datos al inscribirte en zoom. Las constancias de los foros las podrás descargar 2 días hábiles después del evento en vivo.
Si cumpliste los requisitos y no puedes descargar tu constancia escribe a atencion_academica@qsc.com.mx<br/><br/>
      </Card.Description>
   
   

            <Form  >     
                <Form.Field  required  error={errors.correo}>            
                    <label  >Correo:</label>
                          <Input 

                                labelPosition='right'
                                placeholder={strings?strings["correo"]:""} 
                                name="correo"
                                onChange={onChange}
                                value={datos.correo}
                                icon='edit'/>
                </Form.Field>
                <Form.Field  required  error={errors.identificacion}>            
                    <label  >Identificación:</label>
                      <Input 
                            labelPosition='right'
                            placeholder={strings?strings["identificacion"]:""} 
                            name="identificacion"
                            onChange={onChange}
                            value={datos.identificacion}
                            icon='edit'/>
                 </Form.Field>
    
                <Form.Field  required  error={errors.claveCurso}>            
                              <label  >{strings?strings["claveCurso"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["claveCurso"]:""} 
                                    name="claveCurso"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.claveCurso}
                                    options={cursosConstancias}/>
                            </Form.Field>
                </Form>    
    
    
                 {descargarConstancia==0?
                     <Segment basic>    
                                  <Button color='red' onClick={closeModal} >
                                   Cerrar
                                  </Button>
                                  <Button color='green' onClick={onValidar} >
                                    Validar datos
                                  </Button>
                                </Segment> 
                :
                        <>
                        {descargarConstancia==1?
    
                
                            <Segment basic>
                                <Segment inverted>
                                <p>Esta constancia requiere un pago</p>
                                 
                                </Segment>
                                <Segment basic>    
                                <PayPalScriptProvider options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
                                    <div className="paypal-button-container">
                                        <PaypalCheckoutButton curso={cursoPago} handleApprove={handleApprove} />
                                    </div>
                                </PayPalScriptProvider>
                                </Segment>
    
                                <Button color='red' onClick={closeModal} >
                                   Cerrar
                                  </Button>    
    
                            </Segment>
                        :
    
                                <Segment basic>    
                                  <Button color='red' onClick={closeModal} >
                                   Cerrar
                                  </Button>
                                  <Button color='green' onClick={download} >
                                    Descargar
                                  </Button>
                                </Segment> 
    
                            }
                        </>

    
                    }
   
                  
        
   
   
       </Card.Content>
      </Card>
       </Modal.Content>
    </Modal>
)

export default ModalReconocimiento